import { ClientHttpRequester } from '@smarterservices/client-http-requester';
import { createConfig, extendConfig } from '@platform-shared/config';

let sessionConfig = {
  apiUrl: 'http://localhost:8011',
  sessionUiUrl: 'http://localhost:4000/session',
  classCalcApiKey: 'sqlKeyMsCJsqCUPny8jIm27ZeJrPSrU_',
  chromeDownloadLink: 'https://www.google.com/chrome/downloads/',
  spExtensionId: 'njmamkocphdenkffaliamlfabafhmpjl',
  playback: {
    url: 'https://playback.dev.proctoring.media',
  },
  allowedOrigins: [
    'http://localhost:4000',
    'https://app.dev.smarterservices.com',
    'https://app.sub.smarterservices.com',
    'https://app.smarterservices.com',
  ],
  extensionDownloadLink:
    'https://chromewebstore.google.com/detail/smarterproctoring/njmamkocphdenkffaliamlfabafhmpjl',
  spExtensionsToDisable: [
    { id: 'niffbjhghfgccacnebkhbpmgbnhocapg', name: '.*', description: '.*' },
    { id: 'jojmghhfemggnfdmnpihldicgpjhigja', name: '.*', description: '.*' },
  ],
  // TODO: Configure environment-specific agreement application SIDs when dev/staging agreements are available
  agreementsApplicationSid: 'AP6800b9e2e1794dbbbf6ad866194821d3',
  secondCamera: {
    codeLength: 4,
    deviceLinkCodeExpiration: (60 * 4), // minutes x hours
  },
};

if (import.meta.env.VITE_MODE === 'development') {
  sessionConfig.apiUrl = 'https://api.dev.smarterproctoring.com';
  sessionConfig.sessionUiUrl = 'https://app.dev.smarterservices.com/session';
  sessionConfig.playback.url = 'https://playback.dev.proctoring.media';
  sessionConfig.allowedOrigins = [
    'http://localhost:4000',
    'https://app.dev.smarterservices.com'
  ];
}
if (import.meta.env.VITE_MODE === 'sub') {
  sessionConfig.apiUrl =
    'https://api-sub-smarterproctoring-com-md3nlly7gsqim.apitraffic.io';
  sessionConfig.sessionUiUrl = 'https://app.sub.smarterservices.com/session';
  sessionConfig.playback.url = 'https://playback.dev.proctoring.media';
  sessionConfig.allowedOrigins = [
    'http://localhost:4000',
    'https://app.sub.smarterservices.com'
  ];
}
if (import.meta.env.VITE_MODE === 'stage') {
  // TODO: we need to create all of these configs for when this environment is completed by JWeb
  sessionConfig.apiUrl = 'https://api.stage.smarterproctoring.com';
  sessionConfig.sessionUiUrl = 'https://app.stage.smarterservices.com/session';
  sessionConfig.allowedOrigins = ['https://app.stage.smarterservices.com'];
}
if (import.meta.env.VITE_MODE === 'production') {
  sessionConfig.apiUrl = 'https://api.smarterproctoring.com';
  // TODO: when we release, we may have to adjust the following two configs
  sessionConfig.spExtensionId = 'jojmghhfemggnfdmnpihldicgpjhigja';
  sessionConfig.sessionUiUrl = 'https://app.smarterservices.com/session';
  sessionConfig.playback.url = 'https://playback.proctoring.media';
  sessionConfig.extensionDownloadLink =
    `https://chromewebstore.google.com/detail/smarterproctoring/${sessionConfig.spExtensionId}`;
  sessionConfig.spExtensionsToDisable = [
    { id: 'njmamkocphdenkffaliamlfabafhmpjl', name: '.*', description: '.*' },
    { id: 'jojmghhfemggnfdmnpihldicgpjhigja', name: '.*', description: '.*' },
  ];
  sessionConfig.allowedOrigins = ['https://app.smarterservices.com'];
  sessionConfig.agreementsApplicationSid = 'AP6800b9e2e1794dbbbf6ad866194821d3';
}


const baseConfiguration = createConfig(import.meta.env.VITE_MODE);
const config = extendConfig('session', sessionConfig, baseConfiguration);

export default config;
export { config };

// Build our requester with default configs
const requesterConfig = {
  apiUrl: config.proctoring.api.baseUrl,
  retry: {
    enabled: true,
  },
};
export let api = ClientHttpRequester(requesterConfig);